export class ComponentType {
    componentTypeId: number;
    name: string;
    subName: string;
    totalItems: number;
}